// Date 객체를 사용자 로컬 timezone 기준의 "YYYY-MM-DD" 문자열로 변환한다.
// 백엔드의 날짜 단위 필드(`TIME_PROJECT.timestamp` 등) 전송에 사용한다.
//
// 이름이 "Local" 인 이유: `getFullYear()/getMonth()/getDate()` 가 브라우저 로컬 timezone
// 기준으로 동작하므로, 같은 Date 객체라도 사용자 PC timezone 에 따라 출력이 달라진다.
// 또한 표준 `Date.prototype.toDateString()` 이 "Tue May 20 2026" 형태의 영문 wall-clock
// 문자열을 반환하는 것과 동작·출력이 모두 다름을 이름으로 구분한다.
export function toLocalDateString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
